import * as Scroll from 'react-scroll';

export const scrollToTop = () => {
  if (typeof window !== 'undefined') {
    Scroll?.animateScroll?.scrollToTop();
  }
};
